export default {
  state: {
    notification: {
      read: 'false'
    }
  },
  getters: {
    getNotification(state){
      return state.notification;
    },
    getNotificationReadStatus(state){
      return state.notification.read;
    }
  },
  mutations: {
    setNotification(state, param){
      state.notification = param;
    },
    setNotificationReadStatus(state, param){
      state.notification.read = param;
    }
  },
  actions: {
    setNotification(context, param){
      context.commit('setNotification', param);
    },
    setNotificationReadStatus(context, param){
      context.commit('setNotificationReadStatus', param);
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/notification.js